import { FIRST_NAMES_WORKING_DAYS } from "@/constants/homepage";
import { PORTFOLIO_REVIEW_PRICE_DISPLAY } from "@/components/portfolio-review/config";

const firstNamesTiming = FIRST_NAMES_WORKING_DAYS
  ? `within ${FIRST_NAMES_WORKING_DAYS} working days of`
  : "in days, not weeks, after";

export const foundersFaqs = [
  {
    q: "How fast will we see the first names?",
    a: `First names arrive ${firstNamesTiming} the brief call. No month of sorting CVs first.`,
  },
  {
    q: "Why not just post the job ourselves?",
    a: "You can, and then you sort the applications yourself. A bad design hire costs months, and a good one ships the product that sells. We take the screening off your plate, so your time goes into interviews.",
  },
  {
    q: "How much of our time does it take?",
    a: "About 30 minutes on the brief call to agree the role and the hiring criteria, then your feedback on the first names. After that, your time goes into the interviews.",
  },
  {
    q: "How do you assess designers?",
    a: "We read each portfolio by hand against the criteria agreed in your brief. Every candidate gets a score from 0 to 3 on craft, research, systems thinking and storytelling, plus strengths, questions to ask and risks to weigh.",
  },
  {
    q: "We need someone local. Can you do that?",
    a: "Yes. We search across 15 European countries. If the role needs someone on site, we set that in the brief from the start.",
  },
  {
    q: "Who makes the final decision?",
    a: "You do, every time. We screen, rank and coordinate. You run the interviews and choose who to hire.",
  },
];

export const portfolioReviewFaqs = [
  {
    q: "What exactly do I get?",
    a: "Two options. A free 15-minute review that names what's blocking you, or the paid 60-minute Hiring Manager Portfolio Review, which ends with a PDF action plan of what to fix.",
  },
  {
    q: `What's free vs ${PORTFOLIO_REVIEW_PRICE_DISPLAY}?`,
    a: `Free names the bottleneck and whether a full session is worth it. The ${PORTFOLIO_REVIEW_PRICE_DISPLAY} session goes deep on your portfolio and story, with notes you can act on.`,
  },
  {
    q: "Is this a real person or AI?",
    a: "A real person. The session is live with Guidione, not an automated score.",
  },
  {
    q: "How much does it cost?",
    a: `The full Hiring Manager Portfolio Review is ${PORTFOLIO_REVIEW_PRICE_DISPLAY}, and the 15-minute review is free. You pay when you book the paid session.`,
  },
  {
    q: "What if I'm not happy?",
    a: "If you're not happy with your session, we'll give you a full refund, no questions asked.",
  },
  {
    q: "Will logos bias the feedback?",
    a: "No. Work over logos. Your portfolio is judged on what it shows, not where you've worked.",
  },
  {
    q: "Who is this for?",
    a: "Product, UX, and UI designers who want a hiring-side read on their portfolio before they apply, junior to lead.",
  },
  {
    q: "What do I need to send?",
    a: "Your portfolio URL and LinkedIn. A rough role target helps if you have one.",
  },
  {
    q: "How does this help me get hired?",
    a: "You fix what makes hiring managers skip your portfolio before you send it out again. Your next applications start from a stronger signal.",
  },
];
